import { seoSections } from '@/mocks/seoContent';

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <div className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-2">
            HIPO BUY
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            Why Choose Hipobuy Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-foreground-900 rounded-2xl p-6 md:p-8 flex flex-col justify-between">
            <div>
              <div className="w-10 h-10 rounded-lg bg-foreground-700 flex items-center justify-center mb-5">
                <span className="text-background-50 font-bold text-lg font-heading">H</span>
              </div>
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold mb-4">
                Structured &amp; Organized
              </h3>
              <p className="text-background-50/60 text-sm leading-relaxed">
                Products organized into 14 logical categories. No more random search results. Everything is structured for quick discovery and easy comparison.
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Carefully%20styled%20wardrobe%20rack%20with%20coordinated%20neutral%20tone%20outfits%20hanging%20neatly%2C%20minimal%20dressing%20room%20setting%2C%20soft%20diffused%20daylight%2C%20warm%20beige%20walls%2C%20modern%20organizational%20concept%2C%20premium%20fashion%20editorial%2C%20clean%20composition&width=800&height=600&seq=feature-lookbook-v3&orientation=landscape"
              alt="Product research with Hipobuy Spreadsheet"
              className="w-full h-full object-cover min-h-[320px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute top-4 left-4 bg-black/50 backdrop-blur-sm text-background-50 text-xs font-semibold px-3 py-1.5 rounded-full">
              <span className="w-3 h-3 inline-flex items-center justify-center mr-1">
                <i className="ri-flashlight-line text-[10px]"></i>
              </span>
              Research Faster
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="text-background-50 text-xl font-heading font-bold">
                Research Faster
              </h3>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <h3 className="text-foreground-950 text-3xl md:text-4xl font-heading font-bold mb-4">
              Compare &amp; Save
            </h3>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              Side-by-side product comparison makes it easy to evaluate options and find the best value for your needs.
            </p>
            <div className="space-y-3">
              <div className="flex items-center justify-between py-2.5 border-b border-background-200/50">
                <span className="text-sm font-semibold text-foreground-900">Hipobuy</span>
                <span className="text-xs text-accent-600 font-medium">Excellent</span>
              </div>
              <div className="flex items-center justify-between py-2.5 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">Kakobuy</span>
                <span className="text-xs text-foreground-400">Good</span>
              </div>
              <div className="flex items-center justify-between py-2.5 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">CSSBuy</span>
                <span className="text-xs text-foreground-400">Good</span>
              </div>
              <div className="flex items-center justify-between py-2.5">
                <span className="text-sm text-foreground-500">Superbuy</span>
                <span className="text-xs text-foreground-400">Good</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-16">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="py-3 pr-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                  <th className="py-3 pr-4 text-sm font-semibold text-accent-600 whitespace-nowrap">
                    Hipobuy Spreadsheet
                  </th>
                  <th className="py-3 text-sm font-semibold text-foreground-400 whitespace-nowrap">
                    Traditional Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {seoSections.comparison.rows.map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/50">
                    <td className="py-3.5 pr-4 text-sm text-foreground-700">{row.feature}</td>
                    <td className="py-3.5 pr-4 text-sm text-accent-700 font-medium">{row.hipobuy}</td>
                    <td className="py-3.5 text-sm text-foreground-400">{row.traditional}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}